/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementprefix2Inputs */



/**
* | output |
* | --- |
* | "By creating an account or logging in, you agree to our" |
*
* @param {Authagreementprefix2Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementprefix2 = /** @type {((inputs?: Authagreementprefix2Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementprefix2Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("By creating an account or logging in, you agree to our")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("En créant un compte ou en vous connectant, vous acceptez les")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Indem Sie ein Konto erstellen oder sich anmelden, stimmen Sie unseren")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("建立帳戶或登入即表示您同意我們的")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("계정을 만들거나 로그인하면 ")
	return /** @type {LocalizedString} */ ("アカウント登録またはログインを行うと、")
});
export { authagreementprefix2 as "authAgreementPrefix" }